import React from 'react';
export function PressStrip() {
  const items = ['Detroit Pistons Game', 'Community Pop-Ups', 'National Outreach Events', 'Lifeline Program Partner', 'Local Health Fairs'];
  // Duplicate items for seamless marquee
  const marqueeItems = [...items, ...items, ...items];
  return <div className="bg-brand-black border-y border-brand-gold/20 py-4 overflow-hidden flex items-center" data-id="element-128">
      <div className="flex whitespace-nowrap animate-[marquee_30s_linear_infinite]" data-id="element-129">
        {marqueeItems.map((item, idx) => <div key={idx} className="flex items-center mx-8" data-id="element-130">
            <span className="text-brand-gold/60 font-serif italic text-sm mr-3" data-id="element-131">
              AS SEEN AT
            </span>
            <span className="text-brand-gold font-bold tracking-wider uppercase text-sm" data-id="element-132">
              {item}
            </span>
            <span className="mx-8 text-brand-gold/30" data-id="element-133">•</span>
          </div>)}
      </div>
      <style data-id="element-134">{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `}</style>
    </div>;
}